import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import { formToFlow } from '@/helpers/APIconnection';
export default {
  props: {
    onclose: Function,
    viewConfig: Object
  },
  computed: {
    filteredClients() {
      return Object.values(this.viewConfig.clients || {}).filter(c => !c.removed);
    }
  },
  methods: {
    FilterCompanyGroups: function (groups = []) {
      return groups?.filter(g => !g.removed);
    },
    RemoveClient: function (client) {
      if (!client) return;
      this.$state.ui.promptModal = {
        title: "¿ Estás seguro/a ?",
        text: `La empresa “${client.fieldsValues.nombreEmpresa}” va a ser eliminada de tu registro aunque las altas/bajas que hayas generado en ella se mantendrán disponibles en el apartado Altas/Bajas.`,
        footer: [{
          click: () => this.$state.ui.promptModal = undefined,
          text: "Cancelar",
          variant: 'outlined'
        }, {
          click: async () => {
            const response = await formToFlow.user.client.delete(client.credentials.client);
            if (response?.status === 200) {
              client.removed = true;
            }
            this.$state.ui.promptModal = undefined;
          },
          text: "Eliminar"
        }]
      };
    },
    RemoveGroups: function (groups, company) {
      if (!groups) return;
      const text = groups.length > 1 ? `Los grupos ${groups.map(g => `“${g.text}”`).join(', ')} van a ser eliminados de tu registro aunque las altas/bajas que hayas generado en ellos se mantendrán disponibles en el apartado Altas/Bajas.` : `El grupo ${groups.map(g => `“${g.text}”`).toString()} va a ser eliminado de tu registro aunque las altas/bajas que hayas generado en el se mantendrán disponibles en el apartado Altas/Bajas.`;
      this.$state.ui.promptModal = {
        title: "¿ Estás seguro/a ?",
        text,
        footer: [{
          click: () => this.$state.ui.promptModal = undefined,
          text: "Cancelar",
          variant: 'outlined'
        }, {
          click: async () => {
            const deletionPromises = groups.map(async g => {
              const groupKey = Object.keys(company.fields).find(key => company.fields[key].validValues?.some(validValue => validValue.key == g.key));
              const response = await formToFlow.group.delete(company._id, groupKey, g.key);
              if (response.status == 200) {
                g.removed = true;
                g.selected = false;
              }
              return response;
            });
            await Promise.all(deletionPromises);
            this.$state.ui.promptModal = undefined;
          },
          text: "Eliminar"
        }]
      };
    },
    SendEmail: function (company) {
      if (!company) return;
      if (!this.FilterCompanyGroups(company.groups)?.length) {
        company.open = true;
        this.$createToastMessage({
          key: 'no-groups',
          text: `Necesitas crear al menos un grupo en la empresa ${company.fieldsValues.nombreEmpresa} para continuar.`,
          type: 'error',
          alive: 3000,
          fixed: true,
          close: false
        });
        return;
      }
      this.$state.ui.promptModal = {
        title: "Enviar email",
        text: `Vas a dar acceso a <b>${company.fieldsValues.email}</b>.`,
        footer: [{
          click: () => this.$state.ui.promptModal = undefined,
          text: "Cancelar",
          variant: 'outlined'
        }, {
          click: async () => {
            const response = await formToFlow.user.sendemail(company.credentials.client);
            this.$state.ui.promptModal = undefined;
            if (response?.status === 200) {
              this.$createToastMessage({
                key: 'success',
                leadingIcon: 'icon-check',
                text: `El email se ha enviado correctamente a <b>${company.fieldsValues.email}</b>`,
                type: 'secondary',
                alive: 4000,
                fixed: true,
                close: false
              });
            } else {
              this.$createToastMessage({
                key: 'email-error',
                text: 'Ha ocurrido un error al enviar el correo',
                type: 'error',
                alive: 3000,
                fixed: true,
                close: false
              });
            }
          },
          text: "Enviar"
        }]
      };
    }
  }
};